export const reportStateEnum = {
    VALIDATED: 5,
    REPORTFILLED: 10,
    REPORT: 20,
    PLANNING: 23,
    NEEDS: 30,
};

export const reportTypeEnum = {
    SITE: 10,
    ABSENT: 20,
};
